import { Injectable, ElementRef } from '@angular/core';
import { Subject } from 'rxjs/Subject';

import * as constants from './keyboard.constants';
export * from './keyboard.constants';

export class KeyboardModifiers {
  ctrl: boolean = false;
  alt: boolean = false;
  shift: boolean = false;

  constructor(...modifiers: string[]) {
    modifiers.forEach((m) => this[m] = true);
  }

  toString(): string {
    const mod = constants.KEYBOARD_MODIFIERS;
    return [mod.ctrl, mod.alt, mod.shift]
      .filter((f) => this[f])
      .join('+');
  }

  matches(km: KeyboardModifiers): boolean {
    return km
      && km.ctrl === this.ctrl
      && km.alt === this.alt
      && km.shift === this.shift;
  }

  static fromKeyboardEvent(k: KeyboardEvent): KeyboardModifiers {
    var km = new KeyboardModifiers();
    km.ctrl = k.ctrlKey;
    km.alt = k.altKey;
    km.shift = k.shiftKey;
    return km;
  }
}

export class KeybindDescription {
  modifiers: KeyboardModifiers;
  code: number;
  name: string;

  constructor(key: number, ...modifiers: string[]) {
    this.code = key;
    this.name = constants.KEYBOARD_CODES[(key || 0).toString()];
    this.modifiers = new KeyboardModifiers(...modifiers);
  }

  toString(): string {
    return `${this.modifiers.toString()}+${this.name}`;
  }

  matches(kd: KeybindDescription): boolean {
    return kd
      && this.code === kd.code
      && this.modifiers.matches(kd.modifiers);
  }

  static fromKeyboardEvent(k: KeyboardEvent): KeybindDescription {
    var kd = new KeybindDescription(k.keyCode);
    kd.modifiers = KeyboardModifiers.fromKeyboardEvent(k);
    return kd;
  }
}

@Injectable()
export class KeybindService {
  private _keybinds: Subject<KeybindDescription>;

  constructor() {
    this._keybinds = new Subject();
  }

  bind(kb: KeybindDescription) {
    return this._keybinds
      .filter(this.verifyEvent(kb));
  }

  emitKeypress(k: KeyboardEvent) {
    if (k.repeat) return;
    this._keybinds.next(KeybindDescription.fromKeyboardEvent(k));
  }

  verifyEvent(kb: KeybindDescription) {
    return (event: KeybindDescription): boolean => event && event.matches(kb);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/keybind.service.ts